import { Component, Input } from "@angular/core";

import { SidebarHeader } from "./types";

@Component({
  selector: "ta-subsection-header-item",
  templateUrl: "./subsection-header-item.template.html"
})
export class SubsectionHeaderItemComponent {
  @Input()
  header: SidebarHeader;

  @Input()
  subsectionLink: string;

  @Input()
  active: boolean = false;

  @Input()
  isLast: boolean = false;

  hover: boolean = false;
}
